import { useRecoilState, useResetRecoilState } from "recoil";
import { myTaxSelectedTaxDeclarationState } from "my-tax/states/selected-tax-declaration-state";

const useSelectedTaxDeclaration = () => {
  const [selected, setSelected] = useRecoilState(myTaxSelectedTaxDeclarationState);
  const reset = useResetRecoilState(myTaxSelectedTaxDeclarationState);
  return {
    selected,
    setSelected,
    reset,
  };
};

export default useSelectedTaxDeclaration;
